import { Fragment } from 'react'
import { User } from 'types/user'

const yesNo = (value?: boolean) => (value ? 'Yes' : 'No')

/**
 * Store app (picker) details of a user - view only. This data is managed in
 * Order Tracker, so it is shown compactly instead of as form inputs.
 */
const StoreAppDetails = ({ user }: { user?: User }) => {
  const rows: [string, string][] = [
    ['Picker ID', user?.externalPickerId || '-'],
    ['Picker Name', user?.pickerName || '-'],
    ['Supervisor PIN', user?.pinId || '-'],
    ['Can Cancel Order', yesNo(user?.canCancelOrder)],
    ['Void / Complete Report', yesNo(user?.canGenerateVoidCompleteReport)],
    ['Price Label Access', yesNo(user?.canAccessPriceLabel)],
  ]

  return (
    <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <p className="text-sm font-bold text-sidebar-primary">Store App</p>
      <p className="mb-2 text-[11px] text-gray-500">
        View only - managed in Order Tracker.
      </p>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
        {rows.map(([label, value]) => (
          <Fragment key={label}>
            <dt className="text-gray-500">{label}</dt>
            <dd className="font-medium text-gray-900">{value}</dd>
          </Fragment>
        ))}
      </dl>
    </div>
  )
}

export default StoreAppDetails
